import React, { createContext, useCallback, useContext, useState } from "react";
import dayjs from "dayjs";

const STORAGE_KEY = "fleeiq_date_filter";
export const DATE_FILTER_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const getTodaySelection = () => {
  const today = dayjs();
  return {
    type: "date",
    value: today.format("YYYY-MM-DD"),
    from: today.startOf("day").format(DATE_FILTER_FORMAT),
    to: today.endOf("day").format(DATE_FILTER_FORMAT),
  };
};

const readStoredSelection = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (stored?.type && stored?.from && stored?.to) return stored;
  } catch {
    return getTodaySelection();
  }
  return getTodaySelection();
};

const DateFilterContext = createContext();

export const DateFilterProvider = ({ children }) => {
  const [selection, setSelectionState] = useState(readStoredSelection);

  const setSelection = useCallback((next) => {
    setSelectionState(next);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      return;
    }
  }, []);

  const resetSelection = useCallback(() => {
    setSelection(getTodaySelection());
  }, [setSelection]);

  return (
    <DateFilterContext.Provider
      value={{
        from: selection.from,
        to: selection.to,
        selection,
        setSelection,
        resetSelection,
      }}
    >
      {children}
    </DateFilterContext.Provider>
  );
};

export const useDateFilter = () => useContext(DateFilterContext);
